import {
  ClientApiResponse,
  CollectionApiResponse,
  InteractionHistoryResponse,
  NextInteraction,
  YtdKpiTableApiResponseResults,
} from './types';
import { LinkableClient } from '@/types/SalesChurn';

export type State = {
  loading: boolean;
  client: ClientApiResponse;
  group: ClientApiResponse | null;
  ytdKpiDataIsLoading: boolean;
  ytdKpiData: Array<YtdKpiTableApiResponseResults> | null;
  collections: Array<CollectionApiResponse>;
  collectionsLoading: boolean;
  nextInteraction: NextInteraction;
  interactionError: boolean;
  linkableClients: LinkableClient[];
  linkModalLoading: boolean;
  linkModalSubmitting: boolean;
  interactionHistory: Array<InteractionHistoryResponse>;
  interactionHistoryLoading: boolean;
  opportunityOpen: { [taskId: string]: boolean };
};

export const state: State = {
  loading: true,
  client: {} as ClientApiResponse,
  group: null,
  ytdKpiDataIsLoading: true,
  ytdKpiData: null,
  collections: [],
  collectionsLoading: true,
  nextInteraction: {
    userId: '-',
    date: '-',
    dateString: '',
    startTime: '-',
    endTime: '-',
    overdue: false,
    type: '',
    actions: [],
  },
  interactionError: false,
  linkableClients: [],
  linkModalLoading: false,
  linkModalSubmitting: false,
  interactionHistory: [],
  interactionHistoryLoading: false,
  opportunityOpen: {},
};
